import React from 'react';

function Linkedin() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 58">
      <path
        d="M46.429 3.572H3.56C1.596 3.572 0 5.19 0 7.176v42.79c0 1.987 1.596 3.605 3.56 3.605H46.43c1.964 0 3.571-1.618 3.571-3.604V7.177c0-1.987-1.607-3.605-3.571-3.605ZM15.112 46.429H7.7V22.567h7.422V46.43h-.011Zm-3.706-27.12A4.299 4.299 0 0 1 7.11 15.01a4.299 4.299 0 0 1 4.297-4.297 4.306 4.306 0 0 1 4.297 4.297 4.292 4.292 0 0 1-4.297 4.297Zm31.485 27.12H35.48V34.82c0-2.767-.056-6.328-3.85-6.328-3.862 0-4.454 3.014-4.454 6.128v11.808h-7.41V22.567h7.109v3.259h.1c.994-1.875 3.416-3.85 7.02-3.85 7.5 0 8.896 4.944 8.896 11.372v13.08Z"
        fill="#fff"
      />
    </svg>
  );
}

export default Linkedin;
